import Layout, { Card, Empty } from '@/components/Layout'

interface Entry { id: number; entry_type: string; delta: number; note: string | null; at: string; on: string; backfilled: boolean }

function fmt(iso: string) {
  const d = new Date(iso); const p = (n: number) => String(n).padStart(2, '0')
  return `${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
}

// on 是 ISO 日期（YYYY-MM-DD），按字面格式化为 M/D，避免时区偏移
function fmtDay(iso: string) {
  const [, m, d] = iso.split('-')
  return `${Number(m)}/${Number(d)}`
}

export default function Index({ entries }: { entries: Entry[] }) {
  return (
    <Layout>
      <Card title="📒 积分流水" extra={<span className="text-[#707d90] text-[13px]">余额 = 所有流水累加</span>}>
        {entries.length ? (
          <table className="w-full border-collapse text-sm">
            <thead><tr className="text-[#707d90] text-xs"><th className="text-left p-2 border-b border-[#e7ebf2]">时间</th><th className="text-left p-2 border-b border-[#e7ebf2]">事项</th><th className="text-right p-2 border-b border-[#e7ebf2]">积分</th></tr></thead>
            <tbody>
              {entries.map((l) => (
                <tr key={l.id}>
                  <td className="p-2 border-b border-[#e7ebf2] text-[#707d90]">{fmt(l.at)}</td>
                  <td className="p-2 border-b border-[#e7ebf2]">
                    {l.note || l.entry_type}
                    {l.backfilled && (
                      <span className="ml-1.5 text-[11px] px-[7px] py-px rounded-md bg-[#fff4e5] text-[#c97a14] whitespace-nowrap">🗓️ 补打卡 · {fmtDay(l.on)}</span>
                    )}
                  </td>
                  <td className={'p-2 border-b border-[#e7ebf2] text-right font-bold ' + (l.delta >= 0 ? 'text-[#2ec16b]' : 'text-[#ef5350]')}>{l.delta > 0 ? '+' : ''}{l.delta || ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : <Empty>还没有积分记录。</Empty>}
      </Card>
    </Layout>
  )
}
